// extracted by mini-css-extract-plugin
export default {"accent":"#d68f24","accentFade":"#cf3d62","secondary":"#c648d1","primaryLight":"#f3f3f3","primaryDark":"#373b41","tertiary":"#4aa54f","tertiaryFade":"#2a648a"};